import styled from 'styled-components';

import Input from '@polyai/ui/components/atoms/Input';
import themeColors from '@polyai/ui/styles/config/colors';
import text from '@polyai/ui/styles/config/text';

export const HeadlineInput = styled(Input)<{
  $fontSize?: keyof typeof text.size.header;
}>`
  background: transparent;

  &&& {
    width: 100%;
    padding: 0;

    font-family: ${text.font.heading};
    font-size: ${({ $fontSize = 'large' }) => text.size.header[$fontSize]};
    font-weight: ${text.weight.bold};
    font-style: normal;
    line-height: ${text.lineHeight.tight};
    letter-spacing: -0.02em;

    border: none;
    border-color: transparent;
    border-bottom: 1px solid ${themeColors.borderStrong};
    border-radius: 0;

    &:focus {
      border-color: transparent;
      border-bottom: 1px solid ${themeColors.borderStrongInverse};
    }
  }
`;
